<template>
    <button
        class="py-4 w-full text-left border-b cursor-pointer md:hidden border-grey-200"
        aria-label="Open filter drawer"
        @click="$modal.show('ListingDrawer')"
    >
        <p class="container flex items-center justify-between">
            <span class="text-blue-500">Filter results</span>
            <!-- prettier-ignore -->
            <svg class="flex-shrink-0 w-4 ml-2 text-blue-500" role="img" focusable="false" aria-label="" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path fill="currentColor" d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
        </p>
        <p class="container mt-2 text-grey-500 small">
            Showing all
            {{ activeFacets['ranges'] || '' }}
            {{ activeFacets['brands'] || '' }} products, {{ activeSortLabel }}.
        </p>
    </button>
</template>
<script>
export default {
    props: {
        activeFacets: {
            type: Object,
            required: true
        },
        activeSortLabel: {
            type: String,
            default: null
        }
    }
};
</script>
